import { Container, Grid } from "@mui/material";

import React from "react";

type ContainerProps = {
    children: React.ReactNode;
    component: React.ElementType;
};

const ContentContainer = ({ children, component }: ContainerProps): JSX.Element => (
    <Container>
        <Grid
            container
            component={component}
            rowSpacing={0}
            columnSpacing={2}
            direction="row"
            justifyContent="center"
            alignItems="center"
        >
            <Grid item xs={12} md={10} lg={8}>
                {children}
            </Grid>
        </Grid>
    </Container>
);

export default ContentContainer;
